module.exports = __webpack_public_path__ + "img/angulo-derecho.136bfd18.svg";